import React from "react";
import cx from "classnames";
import s from "./statusBadge.scss";
import { Icon, refresh } from "Icons/index";
import Tooltip from "Components/tooltip/Tooltip";
import t from "Utils/translation";

const deriveDeliveryAccountClasses = (account, isUpdating, isManager) => {
  const { status, status_detail, delete_on } = account;

  let derived;
  if (status_detail === "wait_pay") {
    derived = "wait_pay";
  } else if (isUpdating) {
    derived = "updating";
  } else if (delete_on) {
    derived = "delete_on";
  } else if (status) {
    derived = "enabled";
  } else if (!status && status_detail === "by_customer") {
    derived = "disabled_by_customer";
  } else {
    derived = "disabled";
  }

  let style;
  let tooltip;
  let updating = false;
  if (derived === "wait_pay") {
    style = "border border-[4px] border-[--green] border-solid";
    tooltip = "delivery.account.status.waitingPayment";

    // we don't show payment status to the manager
    if (isManager) {
      tooltip = "delivery.account.status.waitingCustomerApprovalFull";
    }
  } else if (derived === "enabled") {
    style = "bg-[--green]";
    tooltip = "delivery.account.status.enabled";
  } else if (derived === "updating") {
    style = "bg-[--accent]";
    tooltip = "delivery.account.status.updating";
    updating = true;
  } else if (derived === "disabled_by_customer") {
    style = "bg-[--yellow]";
    tooltip = "delivery.account.status.disabledByCustomer";
  } else if (derived === "disabled") {
    style = "bg-[--red]";
    tooltip = "delivery.account.status.disabled";
  } else if (derived === "delete_on") {
    style = "bg-[--green]";
    tooltip = "delivery.account.status.scheduledDeleting";
  }

  return {
    style,
    tooltip,
    updating,
    derived,
  };
};

const StatusBadge = ({ data, isUpdating, type, isManager }) => {
  let style;
  let tooltip;
  let updating = false;
  let derived;

  if (type === "delivery-account") {
    const result = deriveDeliveryAccountClasses(data, isUpdating, isManager);
    style = result.style;
    tooltip = result.tooltip;
    updating = result.updating;
    derived = result.derived;
  }

  return (
    <Tooltip text={t(tooltip)}>
      <div className={cx("rounded-full w-5 h-5 flex items-center justify-center relative", style)}>
        {derived === "delete_on" && (
          <div className="absolute w-3 h-3 bg-yellow-400 right-[-2px] top-[-2px] rounded-full"></div>
        )}

        {updating ? <Icon className={s.syncIcon} svg={refresh} width={"0.75rem"} height={"0.75rem"} /> : ""}
      </div>
    </Tooltip>
  );
};

export default StatusBadge;
